module.exports = __webpack_public_path__ + "static/img/177_phase_function_Paper_PointsHejduk_Prediction.41e3d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/177_phase_function_Paper_PointsHejduk_Prediction.png
// module id = qgbh
// module chunks = 0